export const matterFor_Marketplaces = [
	{
		icon: '🔹',
		title: 'matterForMarketplacesData_title1',
		subtitle: 'matterForMarketplacesData_subtitle1',
	},
	{
		icon: '🔹',
		title: 'matterForMarketplacesData_title2',
		subtitle: 'matterForMarketplacesData_subtitle2',
	},
	{
		icon: '🔹',
		title: 'matterForMarketplacesData_title3',
		subtitle: 'matterForMarketplacesData_subtitle3',
	},
	{
		icon: '🔹',
		title: 'matterForMarketplacesData_title4',
		subtitle: 'matterForMarketplacesData_subtitle4',
	},
];

export const matterForAboveList = [
	{
		text: 'matterForMarketplacesData_textAbove_text1',
	},
];
